import { useState } from 'react';

const photoUrl = url => /^(data:|https?:|blob:)/i.test(url) ? url : `${process.env.REACT_APP_BACKEND_URL || ''}${url}`;

function RequestPhoto({ url, index, onOpen }) {
  const [failed, setFailed] = useState(false);
  if (failed) return <p className="p-3 text-xs text-red-600 border rounded-xl">Foto {index + 1} tidak dapat dimuat. File asli perlu diunggah ulang.</p>;
  return (
    <button type="button" aria-label={`Lihat foto pengajuan ${index + 1}`} onClick={() => onOpen(photoUrl(url))}
      className="rounded-xl overflow-hidden border border-gray-200 hover:opacity-90 transition-opacity">
      <img src={photoUrl(url)} alt={`Foto pengajuan ${index + 1}`} className="w-full h-36 object-cover" onError={() => setFailed(true)} />
      <span className="block py-1 text-xs text-isk-teal">Lihat Foto {index + 1}</span>
    </button>
  );
}

export default function RequestPhotos({ value, onOpen }) {
  let photos;
  try {
    photos = typeof value === 'string' ? JSON.parse(value) : value;
    if (photos == null) photos = [];
    if (!Array.isArray(photos) || photos.some(url => typeof url !== 'string' || !url)) throw new Error('Invalid photos');
  } catch {
    return <div className="p-3 rounded-xl bg-orange-50 border border-orange-200 text-xs text-orange-800"><p className="font-semibold">Foto Pengajuan</p><p>Data foto lama tidak lengkap dan tidak dapat ditampilkan. Pembuat pengajuan perlu mengunggah ulang file asli.</p></div>;
  }
  return <div>
    <p className="text-xs font-semibold text-isk-muted mb-2">Foto Pengajuan ({photos.length})</p>
    {photos.length ? <div className="grid grid-cols-2 gap-2">{photos.map((url, index) => <RequestPhoto key={url + index} url={url} index={index} onOpen={onOpen} />)}</div>
      : <p className="text-xs text-isk-muted">Pembuat pengajuan belum mengunggah foto.</p>}
  </div>;
}
